import LoadingThrobber from './LoadingThrobber';

export default LoadingThrobber;
